import { render, staticRenderFns } from "./modifyOrderNo.vue?vue&type=template&id=7c20ebde"
import script from "./modifyOrderNo.vue?vue&type=script&lang=js"
export * from "./modifyOrderNo.vue?vue&type=script&lang=js"
import style0 from "./modifyOrderNo.vue?vue&type=style&index=0&id=7c20ebde&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c20ebde')) {
      api.createRecord('7c20ebde', component.options)
    } else {
      api.reload('7c20ebde', component.options)
    }
    module.hot.accept("./modifyOrderNo.vue?vue&type=template&id=7c20ebde", function () {
      api.rerender('7c20ebde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/components/modifyOrderNo.vue"
export default component.exports